import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/new-message.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-eeffefe6")

_pushScopeId("data-v-eeffefe6")
const _hoisted_1 = { class: "flex flex-col px-8 py-6 space-y-3" }
const _hoisted_2 = { class: "flex flex-row text-gray-lp-300 text-14px" }
const _hoisted_3 = { class: "w-1/4 flex flex-col space-y-2" }
const _hoisted_4 = { class: "font-semibold" }
const _hoisted_5 = { class: "text-gray-lp-300 text-14px font-medium" }
const _hoisted_6 = { class: "text-gray-lp-300 text-14px font-semibold" }
const _hoisted_7 = { class: "font-normal" }
const _hoisted_8 = { class: "font-normal text-gray-lp-500" }
const _hoisted_9 = { class: "text-gray-lp-300 text-14px font-semibold" }
const _hoisted_10 = { class: "font-normal" }
const _hoisted_11 = { class: "font-normal text-gray-lp-500" }
const _hoisted_12 = /*#__PURE__*/_createVNode("h3", { class: "text-gray-lp-300 text-14px font-semibold" }, "Status", -1)
const _hoisted_13 = {
  key: 0,
  class: "w-3/20 flex justify-end items-center mt-5"
}
const _hoisted_14 = { class: "w-12/12" }
const _hoisted_15 = {
  key: 0,
  class: "message-tag"
}
const _hoisted_16 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "new-message"
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Chips = _resolveComponent("Chips")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_Card = _resolveComponent("Card", true)!

  return (_openBlock(), _createBlock(_component_Card, {
    color: "gray-lp-700",
    rounded: "xl",
    class: "relative"
  }, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("h3", _hoisted_4, _toDisplayString(_ctx.data.rcSttNo ? `STT - ${_ctx.data.rcSttNo}` : `Shipment - ${_ctx.data.rcShipmentNo}`), 1),
            _createVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('pusatResolusi.create.noKendala')), 1),
            _createVNode("p", null, _toDisplayString(_ctx.data.rcCaseNumber ? _ctx.data.rcCaseNumber : _ctx.data.rcTicketNo), 1)
          ]),
          _createVNode("div", {
            class: ["flex flex-col space-y-2", _ctx.ableToViewDetail ? 'w-1/5' : 'w-1/4']
          }, [
            _createVNode("h3", _hoisted_6, _toDisplayString(_ctx.$t('pusatResolusi.createdDate')), 1),
            _createVNode("p", _hoisted_7, _toDisplayString(_ctx.data.createdAt), 1),
            _createVNode("p", _hoisted_8, _toDisplayString(_ctx.data.rcCreatedName) + " - " + _toDisplayString(_ctx.data.rcCreatedActorName), 1)
          ], 2),
          _createVNode("div", {
            class: ["flex flex-col space-y-2", _ctx.ableToViewDetail ? 'w-1/5' : 'w-1/4']
          }, [
            _createVNode("h3", _hoisted_9, _toDisplayString(_ctx.$t('pusatResolusi.updatedDate')), 1),
            _createVNode("p", _hoisted_10, _toDisplayString(_ctx.data.updatedAt), 1),
            _createVNode("p", _hoisted_11, _toDisplayString(_ctx.data.rcUpdatedName) + " - " + _toDisplayString(_ctx.data.rcUpdatedActorName), 1)
          ], 2),
          _createVNode("div", {
            class: ["flex flex-col space-y-2", _ctx.ableToViewDetail ? 'w-1/5' : 'w-1/4']
          }, [
            _hoisted_12,
            _createVNode(_component_Chips, {
              label: _ctx.statusData?.label,
              textColor: _ctx.statusData?.textColor,
              color: _ctx.statusData?.backgroundColor,
              fontsize: 14,
              weight: "medium",
              rounded: ""
            }, null, 8, ["label", "textColor", "color"])
          ], 2),
          (_ctx.ableToViewDetail)
            ? (_openBlock(), _createBlock("div", _hoisted_13, [
                _createVNode(_component_LpButton, {
                  onClick: _ctx.toDetail,
                  title: _ctx.$t('pusatResolusi.create.seeDetail'),
                  textColor: "red-lp-100",
                  outline: ""
                }, null, 8, ["onClick", "title"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_14, [
          _createVNode(_component_Chips, {
            label: _ctx.data.rcCategory,
            textColor: "text-gray-lp-300",
            fontsize: 14,
            weight: "medium"
          }, null, 8, ["label"])
        ])
      ]),
      (_ctx.data.newMessage)
        ? (_openBlock(), _createBlock("div", _hoisted_15, [
            _hoisted_16
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
})